import { render } from "./Routes.vue?vue&type=template&id=0a02dad1&scoped=true&lang=pug"
import script from "./Routes.vue?vue&type=script&lang=ts"
export * from "./Routes.vue?vue&type=script&lang=ts"

import "./Routes.vue?vue&type=style&index=0&id=0a02dad1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a02dad1"

export default script